import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledCategoryExplainerWrapper = styled.div`
  .article-card {
    padding: 16px 0;

    .label {
      color: ${theme.colors.green500};
    }
    .author {
      .avatar {
        position: relative;
      }

      .poster {
        line-height: 1.3;
      }
    }
  }
`

export const StyledCategoryExplainerDesktop = styled.div`
  display: flex;
  margin-bottom: 60px;

  .article-card.desktop {
    width: 100%;

    .banner {
      max-height: 244px;
    }

    .title {
      margin-bottom: 12px;
    }
  }

  .first-section {
    width: 50%;
    margin-right: 32px;
  }

  .second-section {
    width: 50%;

    &[data-type='many-item'] {
      display: grid;
      column-gap: 32px;
      grid-template-columns: calc(50% - 16px) calc(50% - 16px);
      grid-template-rows: auto auto;
      row-gap: 16px;
    }
  }
`

export const StyledCategoryExplainerMobile = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: row;
  margin-right: -16px;
  margin-bottom: 39px;
  gap: unset;
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  .article-card {
    width: 78%;
    flex-shrink: 0;
    margin-right: 16px;
  }

  .article-card-one-item {
    width: calc(100% - 16px);
    flex-shrink: 0;
    padding: 16px 0;
    margin-right: 16px;
  }
`
